module.exports = __webpack_public_path__ + "img/estofados.08493a04.webp";